export default {
	get (response) {
		return new Promise(function (resolve, reject) {
			// let blob = new Blob([response.bodyBlob], {type: response.headers.get('content-type')})
			let filename = (response.headers.get('content-disposition') || '').split('filename=')[1]
			filename = filename.replace(/"/g, '')

			let link = document.createElement('a')

			return response.blob()
				.then(function (data) {
					link.href = window.URL.createObjectURL(data)
					link.target = '_self'
					link.download = filename

					resolve(link)
				})
		})
	}
}



// WEBPACK FOOTER //
// ./src/libs/file/fileBlob.js